// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1e9MR","question":"Question_question__1anex","description":"Question_description__5jmX5"};